import React from 'react';
import { R } from '@leverege/value-resolver';
import { Dialogs, Dialog } from '@leverege/ui-elements';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import UserSettingsModelEditor from "../../views/userSettings/UserSettingsModelEditor.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.actions.EditSettingsAction');
const handlesAll = context => {
  return true;
};
export default class EditSettingsAction {
  constructor(opts) {
    this.opts = opts;
    this.id = opts.id;
    this.matches = opts.matches;
    this.handles = opts.handles || handlesAll;
    this.layout = opts.layout || {
      group: ['Settings'],
      groupIcons: [() => tIcon('groupIcons', 'fa fa-cog fa-fw')],
      sort: opts.sort || 'zzzzz'
    };
    if (this.id == null || this.matches == null || this.opts.versionType != null && this.opts.versionPath) {
      throw new Error('EditSettingAction constructor requires an id, versionType and matches');
    }
  }
  appearance = opts => {
    return {
      name: R(this.opts.name, opts) || t('name')
    };
  };
  perform = opts => {
    const {
      context
    } = opts;
    const {
      clientProps
    } = context;
    const {
      settingsPath,
      objectType,
      settings,
      settingsData,
      onSettingsChange
    } = clientProps;
    Dialogs.show({
      component: props => {
        const {
          show,
          onClose
        } = props;
        return /*#__PURE__*/_jsx(Dialog, {
          show: show,
          closeOnEscape: false,
          closeOnDocumentClick: false,
          onClose: onClose,
          children: /*#__PURE__*/_jsx(UserSettingsModelEditor, {
            ...props
          })
        });
      },
      props: {
        editor: this.opts.editor || ModelEditorFactory.get(settings),
        okayLabel: this.opts.okayLabel || t('okayLabel'),
        handleSave: false,
        settingsPath,
        managePersonas: false,
        versionsPath: R(this.opts.versionPath, opts) || (this.opts.versionType ? `${objectType}.${R(this.opts.versionType, opts)}` : null),
        title: R(this.opts.title, opts) || R(this.opts.name, opts) || t('name'),
        editorProps: this.opts.editorProps ? R(this.opts.editorProps, opts) : {
          objectType
        },
        value: settings,
        eventData: settingsData,
        onSave: onSettingsChange
      }
    });
  };
}